import React, { useCallback } from 'react';

import { defaultSAL2040_R01Filter, SAL2040_R01Filter, useSAL2040_R01Store } from 'src/containers/mes/SAL/SAL2040_R01/Store_SAL2040_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { getSAL2040_R01AllCount, getSAL2040_R01List, downloadExcel_SAL2040_R01 } from "./Api_SAL2040_R01";
import { SAL2040_R01Dto } from './Dto_SAL2040_R01';
import { AgGridReact } from 'ag-grid-react';
import { gridRefSelectedRowHandler } from 'src/utils/grid/GridHandlerContent';
import { downloadExcel } from "src/utils/blob/blobUtil";

interface Props {
	gridRef: React.RefObject<AgGridReact<SAL2040_R01Dto> | null>;
	setMessage: (message: string) => void;
}

export const Content_SAL2040_R01 = (props: Props) => {

	const {
		gridRef,
		setMessage,
	} = props;

	const {
		SAL2040_R01Filter, setSAL2040_R01Filter,
		SAL2040_R01PastFilter, setSAL2040_R01PastFilter,
		SAL2040_R01List, setSAL2040_R01List,
		allCount, setAllCount,
		initData,
		setScrollTop,
	} = useSAL2040_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();

	useFetchActionbarAuth("SAL2040_R01");

	const getParams = (filter: SAL2040_R01Filter) => {
		const params: Partial<SAL2040_R01Filter> = {
			compCd: filter.compCd || undefined,
			dateRange: filter.dateRange || undefined,
			customCd: filter.customCd || undefined,
			itemCd: filter.itemCd || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getSAL2040_R01AllCount(getParams(SAL2040_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [SAL2040_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setScrollTop(null);
		setLoadingSpinner(true);

		const responseData = (await getSAL2040_R01List(
			'search',
			getParams(SAL2040_R01Filter),
			SAL2040_R01List.length ?? 0
		));

		let newList = [...responseData.data.data ] as SAL2040_R01Dto[];
		setSAL2040_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				() => {},
				() => true,
			);
			setSAL2040_R01PastFilter(SAL2040_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
			setTimeout(() => setMessage(""), 5000);
		} else {
			showWarning('데이터가 없습니다.');
			setSAL2040_R01List([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [SAL2040_R01Filter, SAL2040_R01List, setSAL2040_R01List, setSAL2040_R01PastFilter, setLoadingSpinner, setMessage, gridRef, renewalAllCount, setScrollTop]);

	const handleExcelClick = useCallback(async () => {
		if (SAL2040_R01List.length === 0) {
			showWarning("엑셀 다운로드할 데이터가 없습니다.");
			return;
		}
		
		try {
			setLoadingSpinner(true);
			const response = await downloadExcel_SAL2040_R01('search', getParams(SAL2040_R01Filter));
			
			// Base64 문자열 → Blob 변환 (SAL1020_R01, SAL1030_R01, SAL2080_R01 패턴)
			const binaryString = atob(response.data.data);
			const byteArray = new Uint8Array(binaryString.length);
			for (let i = 0; i < binaryString.length; i++) {
				byteArray[i] = binaryString.charCodeAt(i);
			}
			const blob = new Blob([byteArray], {
				type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			});
			
			downloadExcel(blob, '기간별 매출현황 조회.xlsx');
			
			showSuccess('엑셀 다운로드가 완료되었습니다.');
		} catch (error) {
			console.error('엑셀 다운로드 실패:', error);
			showError('엑셀 다운로드에 실패했습니다.');
		} finally {
			setLoadingSpinner(false);
		}
	}, [SAL2040_R01List, SAL2040_R01Filter, setLoadingSpinner]);

	return {
		fetchData,
		handleExcelClick,
	};
}

